// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WlM4","col":"styles_col__o-pKX"};